export default __webpack_public_path__ + "static/media/logo.c6551934.png";